<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  testId?: string;
}>();
</script>

<template>
  <tr
    :data-testid="props.testId"
    :class="
      cn(
        'border-b transition-colors dark:border-gray-500 hover:bg-slate-100/50 data-[state=selected]:bg-slate-100 dark:hover:bg-slate-800/50 dark:data-[state=selected]:bg-slate-800',
        props.class
      )
    "
  >
    <slot />
  </tr>
</template>
